import { Component, OnInit } from '@angular/core';

import { GoogleAnalyticsService } from '@app/services/_index';
import { HasAnalytics } from '@app/interfaces/_index';
import { logGoogleAnalytics } from '@app/utilities/console-log.utilities';

@Component({
  selector: 'app-promoted-videos',
  templateUrl: './promoted-videos.component.html',
  styleUrls: ['./promoted-videos.component.scss'],
  standalone: false,
})
export class PromotedVideosComponent implements OnInit, HasAnalytics {
  constructor(private googleAnalyticsService: GoogleAnalyticsService) {}

  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   * Send the query search label to Google Analytics
   * @param category - the source of the google analytics category string (ex. the page or component triggering the action)
   * @param action - the action to be (ex. click)
   * @param dataLabel - the label associated with the action
   */
  sendGoogleAnalytics(category: string, action: string, dataLabel: string): void {
    logGoogleAnalytics(category, action, dataLabel);
    this.googleAnalyticsService.sendEvent(category, action, dataLabel);
  }
}
